import { Duration } from "luxon";

import { generateServiceId, getServiceName } from "@core/domains/identity";

import { ACCOUNT_SERVICE } from "@apis/account/config";

export const MONITORING_SERVICE = {
  ID: generateServiceId("monitoring"),
  LABEL: "status",
  PROBE_INTERVAL: Duration.fromObject({ minutes: 15 }),
  PROBE_MATCH_TOLERANCE: Duration.fromObject({ minutes: 2 }),
  PROBE_RETENTION: Duration.fromObject({ days: 7 }),
  PROBE_TARGETS: {
    accountService: getServiceName(ACCOUNT_SERVICE.ID),
    database: "database",
  },
} as const;
